export default class MovingAverage {
  /**
   * count of values for calculating moving average
   */
  period: number

  private _value: number
  private dividedValues: Array<number>

  /**
   * the current moving average value
   */
  get value () {
    return this._value
  }

  constructor (period: number, initValue?: number) {
    this.period = period
    this._value = initValue || 0
    this.dividedValues = (new Array(period)).fill(this.value / period)
  }

  /**
   * Reset the moving average to given value
   * @param value to set
   */
  reset (value: number) {
    this._value = value
    this.dividedValues = (new Array(this.period))
      .fill(this.value / this.period)
  }

  /**
   * Add a value to the moving average
   * @param value the value to add
   */
  add (value: number) {
    const lastValue = value / this.period
    const firstValue = this.dividedValues.shift()!
    this.dividedValues.push(lastValue)
    this._value += lastValue - firstValue
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helpers/MovingAverage.ts